const getSkillBite = (state) => state.skillBite
const getSessionById = (state, { sessionId }) => state.skillBite?.sessions?.find(session => session.id === sessionId)
const getSectionById = (state, { sessionId, sectionId }) => getSessionById(state, { sessionId })?.sections?.find(section => section.id === sectionId)
const getPageById = (state, { sessionId, sectionId, pageId }) => getSectionById(state, { sessionId, sectionId })?.pages?.find(page => page.id === pageId)
const getBlockById = (state, { sessionId, sectionId, pageId, blockId }) => getPageById(state, { sessionId, sectionId, pageId })?.blocks?.find(block => block.id === blockId)

const updateSkillBite = (state, { updateFunc }) => {
  state.skillBite = updateFunc(state.skillBite)
}

const updateSession = (state, { sessionId, updateFunc }) => {
  state.skillBite = {
    ...state.skillBite,
    sessions: state.skillBite.sessions.map((session) => {
      if (session.id === sessionId) {
        return updateFunc(session)
      }
      return session
    })
  }
}

const updateSection = (state, { sessionId, sectionId, updateFunc }) => {
  state.skillBite = {
    ...state.skillBite,
    sessions: state.skillBite.sessions.map((session) => {
      if (session.id === sessionId) {
        return {
          ...session,
          sections: session.sections.map((section) => {
            if (section.id === sectionId) {
              return updateFunc(section)
            }
            return section
          })
        }
      }
      return session
    })
  }
}

const updatePage = (state, { sessionId, sectionId, pageId, updateFunc }) => {
  state.skillBite = {
    ...state.skillBite,
    sessions: state.skillBite.sessions.map((session) => {
      if (session.id === sessionId) {
        return {
          ...session,
          sections: session.sections.map((section) => {
            if (section.id === sectionId) {
              return {
                ...section,
                pages: section.pages.map((page) => {
                  if (page.id === pageId) {
                    return updateFunc(page)
                  }
                  return page
                })
              }
            }
            return section
          })
        }
      }
      return session
    })
  }
}

const updateBlock = (state, { sessionId, sectionId, pageId, blockId, updateFunc }) => {
  state.skillBite = {
    ...state.skillBite,
    sessions: state.skillBite.sessions.map((session) => {
      if (session.id === sessionId) {
        return {
          ...session,
          sections: session.sections.map((section) => {
            if (section.id === sectionId) {
              return {
                ...section,
                pages: section.pages.map((page) => {
                  if (page.id === pageId) {
                    return {
                      ...page,
                      blocks: page.blocks.map((block) => {
                        if (block.id === blockId) {
                          return updateFunc(block)
                        }
                        return block
                      })
                    }
                  }
                  return page
                })
              }
            }
            return section
          })
        }
      }
      return session
    })
  }
}

export default {
  getSkillBite,
  getSessionById,
  getSectionById,
  getPageById,
  getBlockById,
  updateSkillBite,
  updateSession,
  updateSection,
  updatePage,
  updateBlock
}
